var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { JS_ERROR_EVENT_TYPE } from '../utils/constant';
import { errorEventToJsErrorEvent } from '../utils/js-error-utils';
export var JS_ERROR_EVENT_PLUGIN_ID = 'com.amazonaws.rum.js-error';
var defaultConfig = {
    stackTraceLength: 200
};
var JsErrorPlugin = /** @class */ (function () {
    function JsErrorPlugin(config) {
        var _this = this;
        this.eventHandler = function (errorEvent) {
            _this.recordEvent(JS_ERROR_EVENT_TYPE, errorEventToJsErrorEvent(errorEvent, _this.config.stackTraceLength));
        };
        this.promiseRejectEventHandler = function (event) {
            _this.eventHandler({
                type: event.type,
                error: event.reason
            });
        };
        this.pluginId = JS_ERROR_EVENT_PLUGIN_ID;
        this.enabled = true;
        this.config = __assign(__assign({}, defaultConfig), config);
    }
    JsErrorPlugin.prototype.load = function (context) {
        this.recordEvent = context.record;
        this.addEventHandler();
    };
    JsErrorPlugin.prototype.enable = function () {
        if (this.enabled) {
            return;
        }
        this.addEventHandler();
        this.enabled = true;
    };
    JsErrorPlugin.prototype.disable = function () {
        if (!this.enabled) {
            return;
        }
        this.removeEventHandler();
        this.enabled = false;
    };
    JsErrorPlugin.prototype.getPluginId = function () {
        return this.pluginId;
    };
    JsErrorPlugin.prototype.record = function (error) {
        if (error instanceof ErrorEvent) {
            this.eventHandler(error);
        }
        else {
            this.eventHandler({ type: 'error', error: error });
        }
    };
    JsErrorPlugin.prototype.addEventHandler = function () {
        window.addEventListener('error', this.eventHandler);
        window.addEventListener('unhandledrejection', this.promiseRejectEventHandler);
    };
    JsErrorPlugin.prototype.removeEventHandler = function () {
        window.removeEventListener('error', this.eventHandler);
        window.removeEventListener('unhandledrejection', this.promiseRejectEventHandler);
    };
    return JsErrorPlugin;
}());
export { JsErrorPlugin };
